import * as React from 'react';
import { connect } from 'react-redux';
import SignInEmailPasswordForm from './SignInEmailPasswordForm';
import { signInEmailPassword, signInGoogle } from '../../AuthOperations';

export interface SignInEmailPasswordProps {
  auth: any;
  loginFail: boolean;
  signInEmailPassword: (email: string, password: string) => void;
  signInWithGoogle: () => void;
}

class SignInEmailPasswordContainer extends React.Component<SignInEmailPasswordProps> {
  render() {
    return (
      <div className="section-default">
        <div className="container">
          {
            this.props.auth.status === "LOGIN_FAIL" &&
            <div className="notification is-danger">
              Invalid email/password combination. <br /> Please try again
            </div>
          }
          <div>
            <SignInEmailPasswordForm onSubmit={this.handleSignInSubmit} signIn={this.props.signInWithGoogle}/>
          </div>
        </div>
      </div>
    );
  }

  handleSignInSubmit = (values) => {
    const { email, password } = values;
    this.props.signInEmailPassword(email, password);
  };
}

const mapDispatchToProps = (dispatch) => ({
  signInEmailPassword(email: string, password: string) {
    dispatch(signInEmailPassword(email, password));
  },
  signInWithGoogle() {
    dispatch(signInGoogle());
  },
});

const mapStateToProps = ({ auth }) => {
  return { auth };
};

const SignInEmailPassword = connect(mapStateToProps, mapDispatchToProps)(SignInEmailPasswordContainer);
export { SignInEmailPassword };
